export default "__VITE_ASSET__Y_qwoDem__"